async function showBusinessProfile() {
	const token = window.keycloak?.getBearerToken();
	const headers = new Headers({ Authorization: token });

	const businessProfileSrc = await fetch('/api/user-profiles/profile/current', { headers }).then((res) => res.json());

	const businessProfile = document.getElementById('user-business-profile');

	if (businessProfile && businessProfileSrc?.type === 'BUSINESS_ENTITY') {
		businessProfile.textContent = businessProfileSrc.fullName;
		tippy(businessProfile, {
			content: businessProfileSrc.fullName,
		});
	}

	await requestUserNotifications();
}

async function requestUserNotifications() {
	const url = '/api/notifications/unread/count';

	const headers = new Headers({ Authorization: window.keycloak.getBearerToken() });

	let container = document.querySelector('.menu--user-profile');
	let title = Liferay.Language.get('user.new.notifications.label.nonew');

	const data = await fetch('/api/notifications/unread/count', { headers }).then((res) => res.json());

	if (data?.count >= 0) {
		if (data.count > 0) {
			title =
				Liferay.Language.get('user.new.notifications.label_1') +
				' ' +
				notificationNumerals(data.count, JSON.parse(Liferay.Language.get('user.new.notifications.label_2')));
		}

		const count = container.querySelector('.count');
		count.textContent = data.count > 9 ? '9+' : data.count;

		if (data.count > 0) {
			count.classList.remove('d-none');
		} else {
			count.classList.add('d-none');
		}
	}

	container.setAttribute('data-title', title);
	container.setAttribute('aria-label', title);
	tippy(container.querySelector('#userNotificationsIcon'), { content: title });
}

function notificationNumerals(value, numerals, wovalue) {
	const t0 = value % 10,
		t1 = value % 100,
		vo = [];
	if (wovalue !== true) {
		vo.push(value);
	}
	if (value === 1 && numerals[1]) {
		vo.push(numerals[1]);
	} else if ((value == 0 || (t0 >= 0 && t0 <= 1) || (t0 >= 5 && t0 <= 9) || (t1 > 10 && t1 < 20)) && numerals[0]) {
		vo.push(numerals[0]);
	} else if ((t1 < 10 || t1 > 20) && t0 >= 2 && t0 <= 4 && numerals[2]) {
		vo.push(numerals[2]);
	}
	return vo.join(' ');
}

document.addEventListener('DOMContentLoaded', () => {
	window.keycloak.onAuthenticated(showBusinessProfile);
});
